<template>
  <transition name="page">
    <div class="page-module">
      <div class="radio-popup">
        <div class="popup-head" v-html="title"></div>
        <div class="popup-body">
          <p v-for="(item, i) in desc" :key="'rule'+ i" v-html="item"></p>
        </div>
        <button class="popup-close-btn fl" @click="cancelCallBack()"></button>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "rule_popup",
    props: {
      title: String,
      desc: Array,
      cancelCallBack: Function
    }
  }
</script>

<style scoped>
  @import "../style/css/rule_popup.css";
</style>



// WEBPACK FOOTER //
// src/components/rule_popup.vue